import routeConfig from '../config/routes'

export default {
  methods: {
    redirect() {
      this.$router.push({name: this.getRedirect()})
    },
    getRedirect() {
      // Your details always redirects to payment
      if (this.$route.name == 'your-details') {
        return 'payment'
      }
      return this.$route.params.redirect || this.$route.query.redirect || 'booking'
    },
    getRedirectURL() {
      return this.$router.resolve({
          name: this.getRedirect()
      }).href
    },
    routeLabel(routeName) {
      if (routeConfig[routeName])
        return routeConfig[routeName].label
      return routeName
    }
  },
  computed: {
    prevRouteName() {
      if (this.$route.name == 'your-details')
        return 'extras'
      if (this.$route.name == 'account' && this.prevRoute.name == 'your-details')
        return 'extras'
      if (this.prevRoute && this.prevRoute.name)
        return this.prevRoute.name
      return 'booking'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data() {
    return {
      prevRoute: null
    }
  }
}
